import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { makeIcon } from './playbackStateIndicator.utils';
import { getInitialStyle } from './playbackStateIndicator.style';

export class PlaybackStateIndicator extends Lightning.Component {
  static _template() {
    return _merge(
      {
        PlayIcon: makeIcon('Play'),
        PauseIcon: makeIcon('Pause'),
      },
      getInitialStyle(),
    );
  }

  static _states() {
    return [
      class Playing extends this {
        $enter() {
          this.tag('PlayIcon').visible = true;
          this.tag('PauseIcon').visible = false;
        }
      },
      class Paused extends this {
        $enter() {
          this.tag('PlayIcon').visible = false;
          this.tag('PauseIcon').visible = true;
        }
      },
    ];
  }

  _attach() {
    this._setState('Playing');
  }

  show(state) {
    this._setState(state);
  }
}
